import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';

fontawesome.library.add(light);

(function () {
	"use strict";

	var $ = jQuery;

	//radio js vor checked
	function setSalutationState(){
	    $('.complex-form-gender-fm input, .complex-form-gender-m input').each(function(key, elem){
	        if (elem.checked) {
	            $(elem).closest('div').addClass('checked');
	        } else {
	            $(elem).closest('div').removeClass('checked');
	        }
	    });
	}


    function setRadioBtnsPlease(){
		$(".complex-contact-form .radio label").each(function(index, elem){
    		var isChecked = $(elem).find("input[type='radio']").is(":checked");
	    	if (isChecked) {
	    		$(".complex-contact-form .radio label").removeClass("checked");
	    		$(elem).addClass("checked");
	    	} else {
	    		$(".complex-contact-form .radio label").addClass("checked");
	    		$(elem).removeClass("checked");
	    	}
    	});
	}


	$(document).ready(function(){

		$('.complex-contact-form textarea').attr('placeholder','Bitte senden Sie mir die Verkaufsunterlagen zu und nehmen Sie mit mir Kontakt auf.');
		
		$('.gallery').lightGallery({
			selector: '.gallery-item a'
		});


		$('#content').lightGallery({
			selector: '.galleryImg'
		});



		setRadioBtnsPlease();
	    $(".complex-contact-form .radio label").on('click', function(){
	    	setRadioBtnsPlease();
	    })

		$('.complex-form-gender-fm input, .complex-form-gender-m input').change(function(){
			setSalutationState();
		});
		setSalutationState();

		$(window).scroll(function(){
			var scrolled = $(window).scrollTop();
			var $header = $('#header');
			if (scrolled > 0) {
			    if (!$header.hasClass('scrolled')) {
			        $header.addClass('scrolled');
			    }
			} else if($header.hasClass('scrolled')) {
			    $header.removeClass('scrolled');
			}
		});

		//mobile header nav click toggles also
		$('.navbar-header').on('click', function(event) {
	    	if ($(event.target).hasClass('navbar-header') || $(event.target).hasClass('navbar-brand')) {
	    		$(this).find('.navbar-toggle').trigger('click');
	    	}
	    });

	    $('.navbar-toggler').on('click', function(){
	    	if ($(this).hasClass('active-nav')) {
	    		$(this).removeClass('active-nav');
	    		$('.navbarOuter').removeClass('nav-bg');
	    	} else {
	    		$(this).addClass('active-nav');
	    		$('.navbarOuter').addClass('nav-bg');
	    	}
	    });

	    $('.navbar-collapse').on('shown.bs.collapse', function(){
	    	$('#footer').hide();
	    	$('#content').hide();
	    	$('.sliderOuter').hide();
	    	$('#header').css('position', 'absolute');
	    });

	    $('.navbar-collapse').on('show.bs.collapse', function(){
	    	$('html, body').animate({
	    		scrollTop: $('html, body').offset().top
	    	}, 500);
	    	
	    });

	    $('.navbar-collapse').on('hidden.bs.collapse', function(){
	    });

	    $('.navbar-collapse').on('hide.bs.collapse', function(){
	    	$('#header').css('position', 'fixed');
	    	$('#footer').show();
	    	$('#content').show();
	    	$('.sliderOuter').show();
	    });

	    if ($('.m-slidebanner').length) {
	    	var flky = new Flickity( '.m-slidebanner', {
				cellAlign: 'center',
				contain: true,
				imagesLoaded: true,
				pageDots: false,
				draggable: false,
				prevNextButtons: true,
				arrowShape: 'M0.880493283,6.84156455 C0.707911806,6.74863947 0.565760534,6.60648819 0.472835446,6.43390672 L0,5.96107127 L0.47162146,5.48935473 C0.564892229,5.31505859 0.708301354,5.17162184 0.88257627,5.07831706 L5.66696424,0.292964496 C6.05744917,-0.097599157 6.69061414,-0.0976629777 7.0811778,0.292821949 C7.47174145,0.683306875 7.47180527,1.31647185 7.08132034,1.7070355 L3.82851166,4.9605 L32.7369,4.9605 C33.2891847,4.9605 33.7369,5.40821525 33.7369,5.9605 C33.7369,6.51278475 33.2891847,6.9605 32.7369,6.9605 L3.82785585,6.9605 L7.08124907,10.2138932 C7.47177337,10.6044175 7.47177337,11.2375825 7.08124907,11.6281068 C6.69072478,12.0186311 6.0575598,12.0186311 5.66703551,11.6281068 L0.88049348,6.84156475 L0.880493283,6.84156455 Z'
			});
			window.addEventListener( 'load', function() {
				setTimeout(function(){
					flky.resize();
				}, 100)
			 
			});
	    }

	    $('.m-slidebanner').lightGallery({
	    	selector: '.slide a'
	    });



		//module slider flickity
	/*	var flky = new Flickity( '.m-areas__slider, .m-slidebanner__slider, .casawp-carousel', {
			cellAlign: 'center',
			contain: true,
			wrapAround: true,
			imagesLoaded: true,
			setGallerySize: true,
			pageDots: true,
			prevNextButtons: true
		});*/

		//module gallery fancybox
		// $(".m-gallery__items a").fancybox({
		// 	padding : 0,
		// 	margin : [0,100,0,100],
		// 	openEffect: 'fade',
		// 	closeEffect: 'fade',
		// });

		//arrow jumpers
		$('.m-videobanner__jumparrow, .m-imagebanner__jumparrow, .m-slidebanner__jumparrow').on('click', function(event){
			var $root = $('html, body');
			var $elem = $(this);
			$root.animate({
				scrollTop: $elem.offset().top
			}, 1000);
		});

	});

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js